<template>
  <div id="page-content">
    <div v-if="title" id="header" class="card page-content mb-4">
      <div class="container">
        <div class="flex items-center justify-between">
          <h1 class="text-2xl font-bold mb-0">{{ title }}</h1>
          <slot class="empty:hidden" name="action"></slot>
        </div>
        <div class="border-t pt-3 mt-3 empty:hidden">
          <slot name="subtitle"></slot>
        </div>
      </div>
    </div>
    <div class="card page-content empty:hidden">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps( {
  title: {
    type: String,
    default: undefined
  },
  maxWidth: {
    type: String,
    default: '',
    validator: ( value: string ) => [ '', 'sm', 'md', 'lg', 'xl' ].indexOf( value ) !== -1
  }
} );
</script>

<style>
#page-content .page-content:has(.card:empty) {
  display: none;
}

.product #header { display: none; }

</style>
